/*  hp-spec-size

    Keeps the bed dimension rows in step with the selected size.

    Beds store five measurements per size — custom.bed_length_double,
    _queen, _king, _super_king and the same for width, base height, headboard
    height and mattress size. Liquid picks the right set on page load, but the
    variant picker swaps Queen for King without a reload, and the dimensions
    card would otherwise keep showing the Queen's numbers under the King's
    price. Wrong figures on screen are worse than none.

    Rows for these five are rendered by Liquid even when the loaded size has
    no value, hidden. Without that there would be no node to un-hide when the
    customer picks a size that does have one.

    Only the five per-size rows are touched. Everything else on the card is
    product-level and does not change with the variant.

    Guarded so it is safe to load twice — the theme editor re-renders a
    section on every settings change, and redefining a custom element throws.  */
if (!customElements.get('hp-spec-sizes')) {
  customElements.define(
    'hp-spec-sizes',
    class HpSpecSizes extends HTMLElement {
      connectedCallback() {
        var blob = this.querySelector('[data-hp-spec-sizes]');
        try {
          this.sizes = blob ? JSON.parse(blob.textContent) : null;
        } catch (e) {
          this.sizes = null;
        }

        this.optionIndex = parseInt(this.dataset.optionIndex, 10);
        if (!this.sizes || isNaN(this.optionIndex)) return;

        this.onVariant = this.onVariant.bind(this);
        document.addEventListener('hp:variant:change', this.onVariant);
      }

      disconnectedCallback() {
        document.removeEventListener('hp:variant:change', this.onVariant);
      }

      onVariant(event) {
        var variant = event && event.detail && event.detail.variant;
        if (!variant || !variant.options) return;

        var raw = variant.options[this.optionIndex];
        if (!raw) return;

        this.apply(this.slug(raw));
      }

      /*  "Super King" -> "super_king", matching the metafield key suffix.
          Mirrors Liquid's handle filter closely enough for these values:
          lowercase, non-alphanumerics collapsed to a single underscore.  */
      slug(value) {
        return String(value)
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '');
      }

      apply(size) {
        var values = this.sizes[size];
        var self = this;

        /*  An unknown size is not an error — a bed could gain a Single
            tomorrow with no metafields behind it yet. Blank the five rows
            rather than leaving another size's numbers on screen.  */
        if (!values) values = {};

        Object.keys(this.sizes[Object.keys(this.sizes)[0]] || {}).forEach(function (key) {
          var row = self.querySelector('[data-hp-spec-row="' + key + '"]');
          if (!row) return;

          var cell = row.querySelector('[data-hp-spec-value]');
          if (!cell) return;

          var value = values[key];
          if (value === null || value === undefined || String(value).trim() === '') {
            row.hidden = true;
            cell.textContent = '';
            return;
          }

          value = self.tidy(String(value).trim());

          /*  Same unit rule as hp-spec-row: append only when the row is a
              measurement and the value is not already carrying a unit.  */
          var unit = cell.getAttribute('data-hp-spec-unit') || '';
          var probe = value.toLowerCase();
          if (probe.indexOf('cm') !== -1 || probe.indexOf('mm') !== -1 ||
              probe.indexOf('kg') !== -1 || probe.indexOf('"') !== -1) {
            unit = '';
          }

          cell.textContent = value + unit;
          row.hidden = false;
        });
      }

      /*  Trailing .0 only. These fields are text so 220.0 is unlikely, but a
          re-import from a decimal column will produce it, and 40.05 must not
          become 405 the way the theme's old replace did.  */
      tidy(value) {
        return value.length >= 3 && value.slice(-2) === '.0' ? value.slice(0, -2) : value;
      }
    }
  );
}